import { type Static, Type } from "@sinclair/typebox"
import { IdSchema, NonEmptyStringSchema } from "./common"

export const DeckEntrySchema = Type.Object({
  cardId: IdSchema,
  count: Type.Integer({
    minimum: 1,
    maximum: 3,
  }),
})

export type DeckEntry = Static<typeof DeckEntrySchema>

// mercEntries: unique card entries whose counts must sum to exactly 24 (enforced by semantic validator)
export const DeckSchema = Type.Object({
  deckId: IdSchema,
  name: NonEmptyStringSchema,
  heroId: IdSchema,
  mercEntries: Type.Array(DeckEntrySchema, {
    maxItems: 24,
  }),
})

export type Deck = Static<typeof DeckSchema>
